module.exports = __webpack_public_path__ + "img/how-to_spaces.84b56393.png";